import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";
import InputSelect from "../../../../Component/DigitalMarketing/Forms/InputSelect";

export const AppointmentLabel = [
  {
    tag: InputBox,
    label: "Patient full Name",
    type: "text",
    placeholder: "Enter patient name",
    key_name: "customerName",
    // width: 12,
    validation: "required",
    required: true,
    mandatory: true,
  },
  {
    tag: InputBox,
    label: "Mobile No",
    type: "number",
    placeholder: "Enter mobile no",
    key_name: "phoneNumber",
    validation: "phone",
    required: true,
    mandatory: true,
  },
  // {
  //   tag: InputSelect,
  //   label: "Treatment type",
  //   key_name: "serviceChoosen",
  //   ids: "treatmentTypeName",
  //   list_name: "treatmentTypeName",
  //   validation: "required",
  //   end_point: "Service",
  //   required: true,
  //   mandatory: true,
  // },
  {
    tag: InputBox,
    label: "Email ID(Optional)",
    type: "text",
    placeholder: "Enter email ID",
    validation: "email",
    key_name: "email",
  },
];
